/**
 * Syntax highlighting utilities for export templates
 */

import { highlight, languages } from 'prismjs';

// Import language dependencies after Prism core
import 'prismjs/components/prism-c'; // Required for C++ and C#
import 'prismjs/components/prism-cpp';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-lua';
import 'prismjs/components/prism-javascript';

/**
 * Map platform to syntax highlighter language
 */
export const getPlatformLanguage = (platform: string): string => {
  switch (platform) {
    case 'roblox':
      return 'lua';
    case 'cpp':
      return 'cpp';
    case 'unity':
      return 'csharp';
    case 'godot':
      return 'python'; // GDScript is similar to Python
    case 'custom':
    default:
      return 'javascript';
  }
};

/**
 * Get Prism language for syntax highlighting in editor
 */
export const getPrismLanguage = (platform: string) => {
  const langName = getPlatformLanguage(platform);
  return (languages as any)[langName] || languages.javascript;
};

/**
 * Highlight code for editor
 */
export const highlightCode = (code: string, platform: string) => {
  const language = getPrismLanguage(platform);
  return highlight(code, language, getPlatformLanguage(platform));
};
